module.exports = __webpack_public_path__ + "static/media/blackHeartIcon.970ab03e.svg";